<template>
    <b-notification
        class="vertically-aligned horizontally-spaced"
        :closable="false"
    >
        <div>
            <div
                class="pie-chart"
                :style="`--percentage: ${percentage}%`"
            >
            </div>
            <strong>{{ workflow.strDescription }}</strong>:
            {{ workflow.taskCompletedCount || 0 }} out of {{ workflow.taskCount }} tasks have been completed.
        </div>

        <b-button
            rounded
            size="is-small"
            @click.prevent="showModal()"
        >
            View tasks
        </b-button>
    </b-notification>
</template>

<script>
import TenancyWorkflowModal from './TenancyWorkflowModal';
import PropertyWorkflowModal from './PropertyWorkflowModal';

export default {
    props: {
        workflow: {
            type: Object,
            required: true,
        },
        tenancyPk: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },

    computed: {
        percentage: function () {
            const percentage = (Number(this.workflow.taskCompletedCount) / Number(this.workflow.taskCount)) * 100;
            return percentage.toFixed();
        },
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: (this.type === 'Tenancy' ? TenancyWorkflowModal : PropertyWorkflowModal),
                hasModalCard: true,
                props: {
                    workflowPk: this.workflow.WorkflowPK,
                    tenancyPk: this.tenancyPk,
                },
            });
        },
    },
};
</script>

<style scoped>
    .pie-chart
    {
        background-image: conic-gradient(#48C774 var(--percentage, 0%), #DDDDDD 0);
    }
</style>
